import angular from 'angular';
angular.module('cxHttpServices', []);
